<div class="top-header">
  <div class="header-bar flex justify-between">
    <div class="flex items-center space-x-1">
      <!-- show or close sidebar -->
      <a id="close-sidebar"
         class="btn btn-icon btn-sm rounded-full inline-flex bg-white hover:bg-gray-400 border-white hover:border-white text-neutral-900"
         href="" (click)="toggleShow($event)">
        <i data-feather="menu" class="h-4 w-4"></i>
      </a>
      <!-- show or close sidebar -->
    </div>

    <ul class="list-none mb-0 space-x-1">
      @if (userInfo) {
        <!-- User/Profile Dropdown -->
        <li class="dropdown inline-block relative" (clickOutside)="onClickedOutside2($event)">
          <button (click)="user = !user" class="dropdown-toggle items-center" type="button">
          <span
            class="btn btn-icon btn-sm rounded-full inline-flex bg-gray-600 hover:bg-gray-700 border-gray-600 hover:border-gray-700 text-white"><img
            src="assets/images/avatar/2.jpg" class="rounded-full" alt=""></span>
          </button>
          <!-- Dropdown menu -->
          <div
            class="dropdown-menu absolute end-0 m-0 mt-4 z-10 w-48 rounded-md overflow-hidden bg-white dark:bg-neutral-900 shadow dark:shadow-neutral-900"
            [ngClass]="user ? '' : 'hidden'">
            <div class="relative">
              <div class="py-8 bg-gradient-to-tr from-gray-600 to-red-600"></div>
              <div class="absolute px-4 -bottom-7 start-0">
                <div class="flex items-end">
                  <img [src]="'assets/images/avatar/2.jpg'" class="rounded-full w-10 h-w-10 shadow dark:shadow-gray-700"
                       alt="">

                  <span class="font-semibold text-[15px] ms-1">{{ userInfo.name || userInfo.preferredUsername }}</span>
                </div>
              </div>
            </div>

            <ul class="mt-8 py-2 text-start">
              <li>
                <a [routerLink]="'/user/setting'"
                   class="block text-[14px] font-semibold py-1.5 px-4 hover:text-gray-600"><i
                  class="uil uil-setting text-[16px] align-middle me-1"></i> Settings</a>
              </li>
              <li class="border-t border-gray-100 dark:border-neutral-900 my-2"></li>
              <li>
                <a [routerLink]="" (click)="logout()" class="block text-[14px] font-semibold py-1.5 px-4 hover:text-gray-600"><i
                  class="uil uil-sign-out-alt text-[16px] align-middle me-1"></i> Logout</a>
              </li>
            </ul>
          </div>
        </li><!--end dropdown-->
          <!-- User/Profile Dropdown -->
      }
    </ul>
  </div>
</div>
